import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { ServicePlanFieldError } from 'src/app/models/service-plan/service-plan-field-error'

// Generic, reusable error summary: takes focus and lists problem fields with
// jump-to-field links when a form step blocks Continue. Not Service-Plan-specific in
// behaviour (any future feature can reuse it); it reuses ServicePlanFieldError's
// {controlId, messageKey} shape rather than inventing a parallel one, the same way
// DropdownComponent (core/) already references a domain-specific model (Level).
@Component({
  selector: 'app-error-summary',
  templateUrl: './error-summary.component.html',
  styleUrls: ['./error-summary.component.scss'],
  standalone: false,
})
export class ErrorSummaryComponent implements OnChanges, OnDestroy {
  @Input() titleKey: string = ''
  @Input() errors: ServicePlanFieldError[] = []

  @ViewChild('summaryContainer')
  summaryContainer?: ElementRef<HTMLElement>

  private focusTimeoutId?: ReturnType<typeof setTimeout>

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['errors'] && this.errors.length > 0) {
      // Defer to the next tick so the container is rendered/visible before focus()
      clearTimeout(this.focusTimeoutId)
      this.focusTimeoutId = setTimeout(
        () => this.summaryContainer?.nativeElement.focus(),
      )
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.focusTimeoutId)
  }

  focusField(controlId: string): void {
    document.getElementById(controlId)?.focus()
  }
}
